import { memoize } from "lodash";
import { apiCallFushHosts } from "../../../api/developer-api/api-call-flush-hosts";
import getCorePopUpStore from "../../core/core-popup-store";
import { computed, observable } from "mobx";
import { isDefinedString } from "et3-type-guards";

class FlushHostsStore {
  flushHostsEmail = observable.box<string>("");
  flushHostsPassword = observable.box<string>("");
  flushHostsPassCode = observable.box<string>("");

  isFlushHostsFieldEmpty = computed(() => {
    const flushHostsEmail = this.flushHostsEmail.get();
    const flushHostsPassword = this.flushHostsPassword.get();
    const flushHostsPassCode = this.flushHostsPassCode.get();
    return (
      isDefinedString(flushHostsEmail) &&
      isDefinedString(flushHostsPassword) &&
      isDefinedString(flushHostsPassCode)
    );
  });

  setFlushHostsEmail = (value: string) => {
    this.flushHostsEmail.set(value);
  };

  setFlushHostsPassword = (value: string) => {
    this.flushHostsPassword.set(value);
  };

  setFlushHostsPassCode = (value: string) => {
    this.flushHostsPassCode.set(value);
  };

  flushHosts = async ({
    email,
    password,
    passCode
  }: {
    email: string;
    password: string;
    passCode: string;
  }) => {
    const { status } = await apiCallFushHosts({ email, password, passCode });
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage("FLUSH_HOST_ALERT");
    } else {
      getCorePopUpStore().showSuccessMessage("SUCCESS");
    }
  };
}
const getFlushHostsStore = memoize(
  () => new FlushHostsStore(),
  () => 1
);
export default getFlushHostsStore;
